import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080080FindRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
} & Partial<{
  batchNo: string;
  haisorouteNo: string;
  shohinshubetsuKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B080080FindResponse = {
  batchNo: string;
  batchNm: string;
  haisorouteNo: string;
  haisorouteNm: string;
  shohinshubetsuKbn: string;
  tokuiNm: string;
  nonyuNm: string;
  haisojuni: string;
};

//検索処理
export const B080080Find = (props: B080080FindRequest) => {
  return RestClient.get<PageableResponse<B080080FindResponse[]>>(
    "b080080/find",
    {
      params: props,
    }
  );
};
